<template>
  <!--
    Solo aparece cuando el ajuste se guardó desde el panel. Si todavía sale del `.env` no se dibuja
    nada: lo que importa es el valor, y avisar "esto viene del archivo del servidor" en cada fila era
    ruido en una pantalla donde, con el tiempo, todo va a estar guardado acá.
  -->
  <a
    v-if="origen === 'base'"
    class="a-volver-al-servidor"
    href="volver"
    title="Deja de valer lo guardado acá y vuelve a valer lo que diga el servidor"
    @click.prevent="$emit('volver')"
  >
    <i class="fas fa-undo"></i> Volver al del servidor
  </a>
</template>

<script>
/**
 * El modo de deshacer un ajuste guardado desde el panel.
 *
 * No es "poner vacío": borra la fila, y el ajuste vuelve a salir del `.env`. Por eso es una acción
 * propia y no un campo que se limpia — guardar un vacío en una clave de proveedor dejaría al
 * asistente sin proveedor.
 */
export default {
  name: 'AtomVolverAlServidor',

  props: {
    origen: {
      type: String,
      default: 'env'
    }
  }
}
</script>
